import {
  notifyExternalServices,
  ACTIONS,
} from '@/assets/javascripts/on/external-services/external-services'

function getLineItems(items) {
  return items.map(item => {
    const lineItem = {
      sku: item.variant.sku,
      productSku: item.variant.product.sku,
      productName: item.variant.product.name,
      productType: item.variant.product.product_type,
      price: item.price,
      currency: item.currency,
      quantity: 1,
      size: item.variant.sku.split(item.variant.product.sku)[1].trim(),
    }
    return lineItem
  })
}

export default {
  methods: {
    updateCart(selectedSku, pageContext) {
      this.$store.dispatch('nav/setAdditionalNav', 'mini-cart')
      this.$store.dispatch('order/addCartItems', {
        ids: [selectedSku.productVariantId],
      })
      this.updateServer(selectedSku, pageContext, 'mini-cart')
    },

    async updateServer(selectedSku, pageContext, flashContext) {
      const onDone = () => {
        this.$store.dispatch('checkout/updateApplePayExpressCheckoutRequest')
      }

      const onError = message => {
        const text = message || this.$t('minicart.cart_add_fail')
        this.$store.dispatch('flash/addMessage', {
          text,
          type: 'error',
          context: flashContext,
        })
        this.$store.dispatch('order/fetchData')
      }

      this.$store.commit('recommendation/setMiniCartRecIsLoading', true)
      const response = await this.$store.dispatch('order/updateServer', {
        skuId: selectedSku.productVariantId,
        quantity: 1,
        onDone,
        onError,
      })

      if (response) {
        const lineItems = getLineItems(response.lineItems)
        const addedItem = lineItems.filter(lineItem => lineItem.sku == selectedSku.sku)[0]
        this.trackAddToCart(lineItems, addedItem, pageContext)
        this.dispatchAddToCartEvents(lineItems, addedItem)
      }
    },

    trackAddToCart(lineItems, addedItem) {
      notifyExternalServices({
        action: ACTIONS.addToCart,
        product: addedItem,
      })
      On.DynamicYield.trackAddToCart(lineItems, addedItem)
      if (this.isMinicart) On.DynamicYield.trackMinicartAddToCart(addedItem)
    },

    dispatchAddToCartEvents(lineItems, addedItem) {
      window.dispatchEvent(new CustomEvent('on:addtocart'))

      window.dispatchEvent(
        new CustomEvent('on:update-cart', {
          detail: { addToCart: true },
        })
      )

      window.dispatchEvent(
        new CustomEvent('on:filter-page-add-to-cart', {
          detail: { lineItems, addedItem },
        })
      )
    },
  },
}
